import axios from 'axios'

export default {
    async fetchAll() {
        return await axios.get(`ordertype`)
    },
    async fetchByPermission() {
        return await axios.get(`ordertype/fetchby/permission`)
    },
    async create(model) {
        return await axios.post(`ordertype`, model)
    },
    async fetchById(id) {
        return await axios.get(`ordertype/${id}`)
    },

    async update(id, model) {
        return await axios.put(`ordertype/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`ordertype/${id}`)
    },

    async fetchMasterDocs(){
        return await axios.get(`ordertype/master_doc`)
    }
}
